import React from "react";
import { observer, inject } from "mobx-react";
import { Modal, Button, Breadcrumb, Row, Col, Form, Table, Badge } from "react-bootstrap";
import { STORE_CUSTOMERS, STORE_CREATE_EDIT_CUSTOMER_ORDER, SOURCES_ABTEKA, STORE_CDEK } from "../../../../../constants";
import { CustomersStore, CreateOrderPosition, CreateEditCustomerOrderStore, CdekStore, CdekTerminal } from "../../../../../stores";
import { ConfirmationTable } from "./ConfirmationTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ConfirmationStep2As } from "./ConfirmationStep2/ConfirmationStep2As";
import { ConfirmationStep2Abteka } from "./ConfirmationStep2/ConfirmationStep2Abteka";
import { KeyValue } from "../../../../../common/BaseClasses";
import { DropdownList } from "react-widgets";
import { wrapCheckbox, wrapInput } from "../../../../../common/FormChangeWrapper";
import { formatMoney } from "../../../../../common/Formatting";

interface IProps {
    isOpened: boolean;
    positionsCount: number;
    onSave: (receiverCityId: number,
        toAddress: boolean,
        street: string, building: string, appartment: string,
        address: string,
        terminalCode?: string) => void;
    onClose: () => void;
}

interface IState {
    regions: KeyValue<string, string>[],
    cities: KeyValue<number, string>[],
    terminals?: CdekTerminal[],
    type: "to_delivery_point" | "to_address";
    selectedRegionCode: string;
    selectedCityCode: number;
    selectedCityAddress: string;
    selectedTerminalCode: string;
    selectedTerminalAddress: string;
    calculatedSum?: number;
    street: string;
    building: string;
    appartment: string;
}

@inject(STORE_CDEK)
@observer
export class CdekFormModal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            regions: [],
            cities: [],
            street: "",
            building: "",
            appartment: "",
            selectedRegionCode: "",
            selectedCityCode: -1,
            selectedCityAddress: "",
            selectedTerminalCode: "",
            selectedTerminalAddress: "",
            type: "to_delivery_point"
        }

    }

    // notificationStore = this.customersStore._rootStore.notificationStore;

    cdekStore = (this.props as any)[STORE_CDEK] as CdekStore;


    componentDidUpdate(prevProps: IProps) {
        if (this.props.isOpened !== prevProps.isOpened) {
            if (this.props.isOpened && this.state.regions.length <= 0)
                this.cdekStore.loadRegions((regions: KeyValue<string, string>[]) => {
                    this.setState({
                        regions: regions
                    });
                })
            // this.setState({
            //     type: "to_delivery_point"
            // })
        }
    }

    onChangeRegion = (value: KeyValue<string, string>) => {
        this.setState({ selectedRegionCode: value.Key, selectedCityCode: -1, cities: [] }, () => {
            this.cdekStore.loadCities(this.state.selectedRegionCode, (cities: KeyValue<number, string>[]) => {
                this.setState({
                    cities: cities
                });
            })
        });
    }
    onChangeCity = (value: KeyValue<number, string>) => {

        this.setState({
            selectedCityCode: value.Key,
            selectedCityAddress: value.Value,
            terminals: undefined,
            calculatedSum: undefined
        }, () => {
            if (this.state.type == "to_delivery_point")
                this.cdekStore.loadTerminals(this.state.selectedCityCode, (terminals: CdekTerminal[]) => {
                    this.setState({
                        terminals: terminals
                    });
                })
            this.cdekStore.calculate(this.state.selectedCityCode, this.props.positionsCount,
                this.state.type == "to_address",
                (calculatedSum: number) => {
                    this.setState({
                        calculatedSum: calculatedSum
                    });
                })
        });
    }

    onTypeCheckboxChange = (fieldName: string, value: string, checked: boolean) => {
        this.setState({
            type: value as ("to_delivery_point" | "to_address"),
            calculatedSum: undefined
        }, () => {
            if (this.state.type == "to_delivery_point" && (this.state.terminals == undefined || this.state.terminals.length <= 0))
                this.cdekStore.loadTerminals(this.state.selectedCityCode, (terminals: CdekTerminal[]) => {
                    this.setState({
                        terminals: terminals
                    });
                });
            this.cdekStore.calculate(this.state.selectedCityCode, this.props.positionsCount,
                this.state.type == "to_address",
                (calculatedSum: number) => {
                    this.setState({
                        calculatedSum: calculatedSum
                    });
                })
        })
    }
    onTerminalCheckboxChange = (terminalCode: string, terminalAddress: string) => {
        this.setState({
            selectedTerminalCode: terminalCode,
            selectedTerminalAddress: terminalAddress
        });
    }

    onChangeAddress = (fieldName: string, value: string) => {
        (this as any).setState({
            [fieldName]: value
        });
    }

    onSave = () => {

        if (this.state.type == "to_address") {
            if (this.state.street == undefined || this.state.street.length <= 0 || this.state.building == null || this.state.building.length <= 0) {
                this.cdekStore._rootStore.commonStore.notifyError("Адрес доставки не указан!");
                return;
            }
        } else {
            if (this.state.selectedTerminalCode == undefined || this.state.selectedTerminalCode.length <= 0) {
                this.cdekStore._rootStore.commonStore.notifyError("Не указан терминал доставки!");
                return;
            }
        }




        const address = this.state.type == "to_delivery_point" ? this.state.selectedTerminalAddress :
            `${this.state.selectedCityAddress}, ${this.state.street}, ${this.state.building}, ${this.state.appartment}`;
        this.props.onSave(
            this.state.selectedCityCode,
            this.state.type == "to_address",
            this.state.street,
            this.state.building,
            this.state.appartment,
            address,
            this.state.selectedTerminalCode
        )
    }


    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.onClose} className="modal-xxl" >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5>Настройка доставки</h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col sm={6} lg={4}>
                        <Form.Group as={Row} controlId="formRegion">
                            <Form.Label column sm="4">
                                Регион
                        </Form.Label>
                            <Col sm="8">
                                <DropdownList
                                    textField='Value'
                                    valueField='Key'
                                    filter='contains'
                                    data={[{ Key: "-1", Value: "Не указано" }, ...this.state.regions]}
                                    name="selectedRegionCode"
                                    value={this.state.selectedRegionCode}
                                    onChange={this.onChangeRegion}
                                    placeholder="Укажите регион"
                                />
                            </Col>
                        </Form.Group>
                    </Col>
                    {this.state.cities.length > 0 ? <Col sm={6} lg={4}>
                        <Form.Group as={Row} controlId="formCity">
                            <Form.Label column sm="4">
                                Населенный пункт
                        </Form.Label>
                            <Col sm="8">
                                <DropdownList
                                    textField='Value'
                                    valueField='Key'
                                    filter='contains'
                                    data={[{ Key: "-1", Value: "Не указано" }, ...this.state.cities]}
                                    name="selectedCityCode"
                                    value={this.state.selectedCityCode}
                                    onChange={this.onChangeCity}
                                    placeholder="Укажите город"
                                />
                            </Col>
                        </Form.Group>
                    </Col> : []}
                    <Form.Group as={Row} controlId="formType">
                        <Form.Label column sm="4">
                            Тип доставки
                        </Form.Label>
                        <Col sm="8">
                            <Form.Check inline
                                id="typeCheckboxToDp" onChange={wrapCheckbox(this.onTypeCheckboxChange)} name="type"
                                label="До терминала" type="radio"
                                value={"to_delivery_point"} checked={this.state.type == "to_delivery_point"} />
                            <Form.Check inline
                                id="typeCheckboxToAddress" onChange={wrapCheckbox(this.onTypeCheckboxChange)} name="type"
                                label="До адреса" type="radio"
                                value={"to_address"} checked={this.state.type == "to_address"} />
                        </Col>
                    </Form.Group>

                </Row>
                <Row>
                    {this.state.type == "to_address" ?
                        [<Col sm={6} lg={4} key={"address_1"}>
                            <Form.Group as={Row} controlId="formStreet">
                                <Form.Label column sm="4">
                                    Улица
                                </Form.Label>
                                <Col sm="8">
                                    <Form.Control
                                        type="text"
                                        value={this.state.street}
                                        name="street"
                                        onChange={wrapInput(this.onChangeAddress)}
                                    />
                                </Col>
                            </Form.Group>
                        </Col>,
                        <Col sm={3} lg={2} key={"address_2"}>
                            <Form.Group as={Row} controlId="formBuilding">
                                <Form.Label column sm="6">
                                    Дом
                                </Form.Label>
                                <Col sm="6">
                                    <Form.Control
                                        type="text"
                                        value={this.state.building}
                                        name="building"
                                        onChange={wrapInput(this.onChangeAddress)}
                                    />
                                </Col>
                            </Form.Group>
                        </Col>,
                        <Col sm={3} lg={2} key={"address_3"}>
                            <Form.Group as={Row} controlId="formAppartment">
                                <Form.Label column sm="6">
                                    Квартира (офис)
                                </Form.Label>
                                <Col sm="6">
                                    <Form.Control
                                        type="text"
                                        value={this.state.appartment}
                                        name="appartment"
                                        onChange={wrapInput(this.onChangeAddress)}
                                    />
                                </Col>
                            </Form.Group>
                        </Col>
                        ]
                        : this.state.terminals != undefined && this.state.terminals.length == 0 ? <Col md={12}><h4>В выбранном населенном пункте нет ПВЗ</h4></Col>
                            : (this.state.terminals == undefined || this.state.terminals.length <= 0) ? [] : <Col md={12}>
                                <Table bordered striped size="sm">
                                    <thead>
                                        <tr>
                                            <th>Название ПВЗ</th>
                                            <th>Адрес ПВЗ</th>
                                            <th style={{ width: "100px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {this.state.terminals.map((item, index) => <tr key={index}>
                                            <td>
                                                {item.name}
                                            </td>
                                            <td>
                                                {item.location.addressFull}
                                            </td>
                                            <td className="text-center">
                                                <Form.Check
                                                    id={"terminalCheckbox_" + item.code}
                                                    onChange={wrapCheckbox((fieldName: string, value: string, checked: boolean) => {
                                                        this.onTerminalCheckboxChange(value, item.location.addressFull);
                                                    })}
                                                    name="selectedTerminalCode"
                                                    type="radio"
                                                    value={item.code}
                                                    checked={this.state.selectedTerminalCode == item.code} />
                                            </td>
                                        </tr>)}
                                    </tbody>
                                </Table>
                            </Col>
                    }
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <div style={{ position: "absolute", left: "20px" }}>
                    <h5>Стоимость доставки:
                    <strong>
                            {this.state.calculatedSum == undefined ? <Badge variant="warning">Укажите пункт назначения для рассчета</Badge> :
                                <Badge variant="success">{`${formatMoney(this.state.calculatedSum)} руб.`}</Badge>}
                        </strong>
                    </h5>

                </div>
                <Button variant="secondary" onClick={this.props.onClose}>
                    Отмена
                        </Button>
                <Button variant="primary" onClick={this.onSave}>
                    <FontAwesomeIcon icon="save" />{' '}Сохранить
                        </Button>

            </Modal.Footer>
        </Modal>
    }
}